module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.getApptReq,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline py-1"
  }, [_vm._v("\n    Appointment details\n    "), _c('v-spacer'), _vm._v(" "), (_vm.sharelink) ? [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.sharedialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("share")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "360"
    },
    model: {
      value: (_vm.sharedialog),
      callback: function($$v) {
        _vm.sharedialog = $$v
      },
      expression: "sharedialog"
    }
  }, [_c('share-card', {
    attrs: {
      "links": [_vm.sharelink],
      "relationship-id": _vm.appointment.computed_relationship_id
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Date and time")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n        ")]), _vm._v(" "), (_vm.appointment.client_timezone && _vm.appointment.client_timezone !== _vm.$store.getters.settings.timezone) ? _c('v-list-tile-sub-title', [_vm._v("\n          Client's timezone: " + _vm._s(_vm.appointment.client_timezone) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "Reschedule", _vm.appointment])
      }
    }
  }, [_vm._v("\n          Reschedule\n        ")])], 1)], 1), _vm._v(" "), (_vm.appointment.location && (_vm.appointment.location.address || _vm.appointment.location.name)) ? [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Flexible location")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.location.formatted_address || _vm.appointment.location.address)
    }
  })], 1), _vm._v(" "), (_vm.appointment.location.url) ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "href": _vm.appointment.location.url,
      "target": "_blank",
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("open_in_new")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', {
    on: {
      "click": function($event) {
        _vm.editLocation = true
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "340"
    },
    model: {
      value: (_vm.editLocation),
      callback: function($$v) {
        _vm.editLocation = $$v
      },
      expression: "editLocation"
    }
  }, [_c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save({
          location: _vm.appointment.location
        })
      }
    },
    model: {
      value: (_vm.locationIsValid),
      callback: function($$v) {
        _vm.locationIsValid = $$v
      },
      expression: "locationIsValid"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.apptReq,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              Edit this location\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editLocation = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Place of interest name"
    },
    model: {
      value: (_vm.appointment.location.name),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "name", $$v)
      },
      expression: "appointment.location.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Physical address"
    },
    model: {
      value: (_vm.appointment.location.address),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "address", $$v)
      },
      expression: "appointment.location.address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "link",
      "type": "url",
      "clearable": "",
      "label": "Map address",
      "placeholder": "https://",
      "rules": _vm.urlRules,
      "hint": "Link to an address in google maps or whatever mapping software you use"
    },
    model: {
      value: (_vm.appointment.location.url),
      callback: function($$v) {
        _vm.$set(_vm.appointment.location, "url", $$v)
      },
      expression: "appointment.location.url"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.editLocation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "disabled": !_vm.locationIsValid,
      "loading": _vm.apptReq.loading,
      "color": "primary"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)] : (_vm.appointment.address_data) ? _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Location")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.appointment.address_data.name) + ". " + _vm._s(_vm.appointment.address_data.address) + "\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.productData && _vm.productData.id) ? _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Appointment Type")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.productData.title) + "\n          "), (_vm.appointment.practitioner_name) ? _c('span', [_vm._v(" with " + _vm._s(_vm.appointment.practitioner_name))]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.changeAppointmentType = true
      }
    }
  }, [_vm._v("Change")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "640"
    },
    model: {
      value: (_vm.changeAppointmentType),
      callback: function($$v) {
        _vm.changeAppointmentType = $$v
      },
      expression: "changeAppointmentType"
    }
  }, [_c('v-card', [(_vm.changeAppointmentType) ? _c('transfer-appointment', {
    attrs: {
      "appointment": _vm.appointment
    },
    on: {
      "saved": function($event) {
        _vm.get();
        _vm.changeAppointmentType = false
      },
      "close": function($event) {
        _vm.changeAppointmentType = false
      }
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.relationship && _vm.relationship.id && _vm.appointment.status && _vm.appointment.status.toLowerCase() !== "b") ? _c('div', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Customer information")]), _vm._v(" "), (_vm.appointment.relationships && _vm.appointment.relationships.length > 0 && isNaN(_vm.appointment.relationships[0])) ? _vm._l((_vm.appointment.relationships), function(relationship) {
    return _c('client-list-item', {
      key: relationship.id,
      attrs: {
        "with-details": "",
        "with-whatsapp": "",
        "with-edit": "",
        "relationship-id": relationship.relationship.id,
        "client": relationship.relationship
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.gotoClient(relationship.relationship)
        }
      }
    }, [_c('template', {
      slot: "actions"
    }, [_c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "flat": !_vm.$vuetify.breakpoint.xs,
        "icon": _vm.$vuetify.breakpoint.xs
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.launchSetAppointmentClient({
            value: _vm.appointment,
            withDependent: true
          })
        }
      }
    }, [(_vm.$vuetify.breakpoint.xs) ? _c('v-icon', [_vm._v("manage_accounts")]) : _c('span', [_vm._v("Change")])], 1)], 1), _vm._v(" "), (_vm.sharelink) ? _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "href": _vm.sharelink.url,
              "target": "_blank"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
              }
            }
          }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Open client appointment page")])])], 1) : _vm._e()], 1)], 2)
  }) : _c('client-list-item', {
    attrs: {
      "relationship-id": _vm.relationship.id,
      "client": _vm.relationship.client
    },
    on: {
      "listitem:clicked": function($event) {
        return _vm.gotoClient(_vm.relationship)
      }
    }
  }), _vm._v(" "), (_vm.fullName && _vm.fullName !== _vm.appointment.full_name) ? _c('div', [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n          Patient name: " + _vm._s(_vm.appointment.full_name) + "\n          "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.launchSetAppointmentClient({
          value: _vm.appointment,
          withDependent: true
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1) : _vm._e()], 2) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-list', {
    staticClass: "orange lighten-2 elevation-4",
    attrs: {
      "subheader": "",
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n            Please choose a client\n            "), _c('v-spacer'), _vm._v("\n            The client used the following information when making the appointment\n          ")], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("warning")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.full_name)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.appointment.contact_email))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.appointment.contact_phone))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.launchSetAppointmentClient({
          value: _vm.appointment
        })
      }
    }
  }, [_vm._v("Set client")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.appointment && _vm.appointment.is_online) ? [_c('online-meeting-card', {
    attrs: {
      "withedit": true,
      "editmode": !_vm.appointment.zoom_meeting_id,
      "appointment": _vm.appointment
    }
  })] : _vm._e(), _vm._v(" "), (_vm.codes) ? _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('appointment-codes', {
    attrs: {
      "title": "Codes",
      "with-title": "",
      "with-done": false
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), (_vm.appointment.notes) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-0 mt-4"
  }, [_vm._v("Appointment notes")]), _vm._v(" "), _c('v-card-text', [_c('pre', {
    staticClass: "blue lighten-5 pa-2 caption"
  }, [_vm._v(_vm._s(_vm.appointment.notes))])])], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-2"
  }, [_c('tag-list', {
    attrs: {
      "appointment": _vm.appointment,
      "deleteable": true
    }
  })], 1), _vm._v(" "), (_vm.appointment.recurring_appointment) ? _c('v-card-text', [_c('recurring-appointment-form', {
    attrs: {
      "flat": false
    },
    model: {
      value: (_vm.appointment),
      callback: function($$v) {
        _vm.appointment = $$v
      },
      expression: "appointment"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c10a18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/AppointmentCard.vue
// module id = 1426
// module chunks = 9